var scope_0 = require('/usr/src/app/www/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/abb0eaf4ad9ccba00a595b9db020f055.js').default;
var scope_1 = require('/usr/src/app/www/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_2 = require('/usr/src/app/www/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f0ba766625d3e7a6aaf3ab23a012ede7.js').default;
var scope_3 = require('/usr/src/app/www/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f74f7d991da14469b4e11c22de3890cb.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    